import { map, MapOptions } from "leaflet";
import { bindEsriCredit } from "./mapCredit";

export const createMap = (container: HTMLElement, options?: MapOptions) => {
  requestAnimationFrame(() => {
    container.focus();
  });

  const leafletMap = map(container, {
    center: [0, 0],
    wheelPxPerZoomLevel: 120,
    zoom: 3,
    zoomControl: false,
    zoomDelta: 0.35,
    zoomSnap: 0.25,
    ...options,
  });
  // Tile providers' credits only, without the "Leaflet" prefix.
  leafletMap.attributionControl?.setPrefix(false);
  bindEsriCredit(leafletMap);

  return leafletMap;
};
